import { render, staticRenderFns } from "./OtherReferences.vue?vue&type=template&id=75a8a072&scoped=true&"
import script from "./OtherReferences.vue?vue&type=script&lang=js&"
export * from "./OtherReferences.vue?vue&type=script&lang=js&"
import style0 from "./OtherReferences.vue?vue&type=style&index=0&id=75a8a072&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75a8a072",
  null
  
)

/* custom blocks */
import block0 from "./OtherReferences.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports